<template>
  <div>
    <span 
    class="tag  has-text-bold  is-small"
    :class="color"  style="font-weight:900">
     <b > {{ name }}</b>
      </span>
  </div>
</template>


<script>
export default {
  name: null,

  props: ["id"],

  data() {
    return {
      name: null,
      color: null,
      request: [
        { name: "تم الارسال", id: 1, class: "is-info" },
        { name: "قيد التنفيذ", id: 2, class: "is-warning" },
        { name: "تم الانتهاء", id: 3, class: "is-success has-text-bold" },
        { name: "تم الرفض", id: 4, class: "is-danger" }
      ]
    };
  },
  created() {
    this.name = this.request.find(obj => obj.id === this.id).name;
    this.color = this.request.find(obj => obj.id === this.id).class;
    //   }
  }
};
</script>
